import { createAction } from '@reduxjs/toolkit'
import {
  BuildingStructuralTypes,
  StructuralSettings,
} from '../models/Structural'

export const toggleStructuralType = createAction<{
  item: BuildingStructuralTypes
}>('structural/toggleStructuralType')

export const playStructuralAnimation = createAction(
  'structural/playStructuralAnimation',
)
export const endStructuralAnimation = createAction(
  'structural/endStructuralAnimation',
)
export const resetStructuralState = createAction(
  'structural/resetStructuralState',
)
export const setStructuralSettings = createAction<StructuralSettings[]>(
  'structural/setStructuralSettings',
)
export const showStructuralSettingsModal = createAction<boolean>(
  'structural/showStructuralSettingsModal',
)
export const showLoader = createAction<boolean>('structural/showLoader')
